/* Small, dependency-free carousel controls. Works with the Shopify theme editor. */
if (!customElements.get('mf-scroll-gallery')) {
  customElements.define('mf-scroll-gallery', class extends HTMLElement {
    connectedCallback() {
      this.viewport = this.querySelector('[data-viewport]');
      this.querySelectorAll('[data-direction]').forEach(button => button.addEventListener('click', () => {
        const first = this.querySelector('.mf-gallery__item');
        const distance = first ? first.getBoundingClientRect().width + parseFloat(getComputedStyle(this).getPropertyValue('--mf-gap')) : 300;
        this.viewport?.scrollBy({left: (button.dataset.direction === 'next' ? 1 : -1) * distance, behavior: 'smooth'});
      }));
      this.addEventListener('shopify:block:select', event => {
        const item = [...this.querySelectorAll('[data-block-id]')].find(el => el.dataset.blockId === event.detail.blockId);
        item?.scrollIntoView({behavior: 'smooth', block: 'nearest', inline: 'center'});
      });
    }
  });
}
if (!customElements.get('mf-slideshow')) {
  customElements.define('mf-slideshow', class extends HTMLElement {
    connectedCallback() {
      this.slides = [...this.querySelectorAll('[data-slide]')];
      if (!this.slides.length) return;
      this.index = Math.max(0, this.slides.findIndex(slide => !slide.hidden));
      this.querySelectorAll('[data-direction]').forEach(button => button.addEventListener('click', () => {
        this.show(this.index + (button.dataset.direction === 'next' ? 1 : -1)); this.restart();
      }));
      this.addEventListener('mouseenter', () => this.pause());
      this.addEventListener('mouseleave', () => this.restart());
      this.addEventListener('focusin', () => this.pause());
      this.addEventListener('focusout', event => { if (!this.contains(event.relatedTarget)) this.restart(); });
      this.addEventListener('shopify:block:select', event => {
        const target = this.slides.findIndex(slide => slide.dataset.blockId === event.detail.blockId);
        if (target >= 0) { this.show(target); this.pause(); }
      });
      this.addEventListener('shopify:block:deselect', () => this.restart());
      this.visibilityHandler = () => document.hidden ? this.pause() : this.restart();
      document.addEventListener('visibilitychange', this.visibilityHandler);
      this.restart();
    }
    disconnectedCallback() { this.pause(); document.removeEventListener('visibilitychange', this.visibilityHandler); }
    show(index) {
      this.index = (index + this.slides.length) % this.slides.length;
      this.slides.forEach((slide, n) => { slide.hidden = n !== this.index; });
      const counter = this.querySelector('[data-index]');
      if (counter) counter.textContent = String(this.index + 1).padStart(2, '0');
    }
    pause() { clearInterval(this.timer); this.timer = null; }
    restart() {
      this.pause();
      if (this.dataset.autoplay === 'true' && this.slides.length > 1 && !document.hidden && !window.Shopify?.designMode && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
        this.timer = setInterval(() => this.show(this.index + 1), Number(this.dataset.interval) || 6000);
      }
    }
  });
}
if (!customElements.get('mf-collection-tabs')) {
  customElements.define('mf-collection-tabs', class extends HTMLElement {
    connectedCallback() {
      this.tabs = [...this.querySelectorAll('[role="tab"]')];
      this.panels = [...this.querySelectorAll('[role="tabpanel"]')];
      this.tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => this.activate(index));
        tab.addEventListener('keydown', event => {
          const shift = event.key === 'ArrowRight' ? 1 : event.key === 'ArrowLeft' ? -1 : 0;
          if (!shift) return;
          event.preventDefault();
          const next = (index + shift + this.tabs.length) % this.tabs.length;
          this.activate(next);
          this.tabs[next].focus();
        });
      });
      this.addEventListener('shopify:block:select', event => {
        const selected = this.tabs.findIndex(tab => tab.contains(event.target));
        if (selected >= 0) this.activate(selected);
      });
    }
    activate(index) {
      this.tabs.forEach((tab, i) => { tab.setAttribute('aria-selected', String(i === index)); tab.tabIndex = i === index ? 0 : -1; });
      this.panels.forEach((panel, i) => { panel.hidden = i !== index; });
    }
  });
}
